module.exports = {"id":"160054","name":"Eladio Cubildas","rating":"72","photo":"./data/images/photos/1/160054.png","club":{"name":"Audax Italiano","logo":"./data/images/clubs/AudaxItaliano.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EladioCubildas0.json
// module id = 1199
// module chunks = 0